package music.limasoul.client.shared.user.domain.usecase

import music.jammers.shared.user.domain.model.User
import music.limasoul.client.shared.user.domain.repository.UserRepository

class GetCurrentUserUseCase(
    private val userRepository: UserRepository,
) {

    suspend operator fun invoke(): User =
        userRepository.getCurrent()
}